import React from "react";
import Button from "../../../../shared/button/button";

import indication from "../../../../img/advanced-management/indication.svg";
import AdvancedManagementInfoStep from "../template/AdvancedManagementInfoStep";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";

const AdvancedManagementNoBoundsFound = ({ nextStep } = props) => {

	const handleEvent = (type) => {
		publish(eventType.ACCOUNT_FAMILY, {
			type: type
		})
	}

	return (
		<AdvancedManagementInfoStep
			dataImg={indication}
			dataText={
				<React.Fragment>
					<strong>Você não tem participantes com contas vinculadas.</strong>
					<br />
					Indique um participante clicando no botão abaixo.
				</React.Fragment>
			}
		>
			<Button className="btn-secondary-lg" onClick={() => {
				handleEvent(ACCOUNT_FAMILY_EVENT.button_indicate_now)
				nextStep(1);
			}}>
				Indicar agora
			</Button>
		</AdvancedManagementInfoStep>
	);
};

export default AdvancedManagementNoBoundsFound;
